var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"con_out"},[(_vm.refreshKeepalive)?_c('router-view',{ref:"routerView"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }